import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';



function * createTeamMemberAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/team_members', data.payload)
     yield put({type:'REQUEST_CREATE_TEAM_MEMBER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateTeamMemberAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/team_members/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_TEAM_MEMBER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteTeamMemberAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/team_members/'+data.id)
     yield put({type:'REQUEST_DELETE_TEAM_MEMBER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}




function* Create_team_member(){yield takeEvery('REQUEST_CREATE_TEAM_MEMBER', createTeamMemberAsync);}
function* Update_team_member(){yield takeEvery('REQUEST_UPDATE_TEAM_MEMBER', updateTeamMemberAsync);}
function* Delete_team_member(){yield takeEvery('REQUEST_DELETE_TEAM_MEMBER', deleteTeamMemberAsync);}


export default function* Root_team_members(){
  yield all([
    fork(Create_team_member),
    fork(Update_team_member),
    fork(Delete_team_member)
  ]);
}
